/**
 * Created by Ning Jiang on 10/29/2019.
 */

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {DeadwoodGameMode} from "../gamemode/DeadwoodGameMode";
import {DeadwoodParsedGameData} from "../server/data/DeadwoodParsedGameData";
import {IDeadwoodParsedServerData} from "../server/data/IDeadwoodParsedServerData";
import {DeadwoodStackedWild} from "../symbols/DeadwoodStackedWild";
import {DeadwoodMultiplierView} from "./DeadwoodMultiplierView";

export class DeadwoodMultiplierController extends BaseController {

    public static ADD_MULTIPLIER:string = "deadwoodMultiplierEvent_addMultiplier";
    public static SHOW_END_MULTIPLIER:string = "deadwoodMultiplierEvent_showEndMultiplier";
    public static SHOW_DAGGER:string = "deadwoodMultiplierEvent_showDagger";
    public static HIDE_DAGGER:string = "deadwoodMultiplierEvent_hideDagger";

    private _mode:string;
    private _nextMode:string;
    private _overlayWilds:boolean[][] | undefined;
    private _winRatio:number;

    private _currentMultiplier:number = 0;
    private _endMultiplier:number;
    private _multiplierOnReel:number[];

    private _view:DeadwoodMultiplierView;

    constructor() {
        super();

        this._view = new DeadwoodMultiplierView();
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());

        EventHandler.addEventListener(this, DeadwoodMultiplierController.ADD_MULTIPLIER, (event:GameEvent) => this.onAddMultiplier());
        EventHandler.addEventListener(this, DeadwoodMultiplierController.SHOW_END_MULTIPLIER, (event:GameEvent) => this.onShowEndMultiplier(event.params[0]));

        EventHandler.addEventListener(this, DeadwoodMultiplierController.SHOW_DAGGER, (event:GameEvent) => this.onShowDagger());
        EventHandler.addEventListener(this, DeadwoodMultiplierController.HIDE_DAGGER, (event:GameEvent) => this.onHideDagger());

        // for test:
        // EventHandler.addEventListener(this, ScreenEvent.GAME_START, (event:GameEvent) => this.onShowDagger());
    }

    private onDataParsed(data:IDeadwoodParsedServerData):void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._overlayWilds = data.overlayWilds;
        this._endMultiplier = data.currentMultiplier;
        this._multiplierOnReel = data.multiplierOnReel;
        this._winRatio = (<DeadwoodParsedGameData>data).currentWinRatio;
    }

    private onRestore():void {
        // There is no restore case in main game, so no need to parse mode.
        // the freespin intro will trigger the restore of the endMultiplier.
        // This is only restoring the wild multiplier for previous fs.

        if(this._multiplierOnReel != null) {
            // Restore Wild symbol multiplier
            this._multiplierOnReel.forEach((multiplier:number, reelId:number) => {
                if(multiplier > 0) {
                    const wild:DeadwoodStackedWild = <DeadwoodStackedWild>Reels.getSymbol(reelId, 0);
                    if(wild) {
                        wild.stack!.symbols.forEach((symbol:PIXI.DisplayObject | null) => {
                            (<DeadwoodStackedWild>symbol)?.updateMultiplier(multiplier, false, "normal");
                        });
                    }
                }
            });
        }
    }

    private onBeforeSpinStart():void {
        if(this._nextMode === DeadwoodGameMode.FREESPIN_GUNSLINGER) {
            return;
        }
        this.abortMultiplier(true);
    }

    private abortMultiplier(playHideAnimation:boolean):void {
        if(this._endMultiplier > 1 && this._currentMultiplier != this._endMultiplier) {
            this.onShowEndMultiplier(true);
        }

        this._currentMultiplier = 0;
        this._view.hideMultiplier(playHideAnimation);
    }

    private updateMultiplier(number:number, animate:boolean):void {
        this._currentMultiplier = number;
        const displayNumber:number = this._currentMultiplier === 0 ? 1 : this._currentMultiplier;
        this._view.showMultiplier(displayNumber, this._mode, animate);
        if(animate) {
            // EventHandler.dispatchEvent(new GameEvent(SoundEvent.PLAY_SOUND_EFFECT, this.getMultiplierSound(number)));
        }
    }

    private onAddMultiplier():void {
        this.updateMultiplier(this._currentMultiplier + 1, true);
    }

    private onShowEndMultiplier(animate:boolean):void {
        this.updateMultiplier(this._endMultiplier, animate);
    }

    private onShowDagger():void {
        this._view.addDagger();
    }

    private onHideDagger():void {
        this._view.removeDagger();
        if(this._winRatio == null || this._winRatio === 0) {
            this._endMultiplier = 1;
            this.abortMultiplier(false);
        }
    }

    // TODO: private getMultiplierSound(number:number):string {
    //     switch(number) {
    //         case 1:
    //             return TombstoneSoundConfig.instance.MULTIPLIER1;
    //         case 2:
    //             return TombstoneSoundConfig.instance.MULTIPLIER2;
    //         default:
    //             return TombstoneSoundConfig.instance.MULTIPLIER3;
    //     }
    // }
}